import { isWeComBrowser } from './is-wecom-browser';
import { isMobile } from './is-mobile';
import { getEnv } from './get-env';

export function linkToUlp(urlOrigin: string, isFE = false) {
  const { hostname, href } = window.location;
  const key = isFE ? 'sp' : 'to';
  const url = `${urlOrigin}?url=${hostname}&${key}=${window.btoa(href)}`;
  window.location.href = url;
}

export const isLinkToUlp = (origin: string) =>
  isWeComBrowser() && !isMobile() && getEnv(origin) === 'prod';

export function ulpRedirect(ulpOrigin: string) {
  const { href } = window.location;
  const url = `${ulpOrigin}?redirect=${encodeURIComponent(href)}`;
  window.location.href = url;
}
